export const ORDINAL = ["Northeast", "Northwest", "Southeast", "Southwest"];
